
export const ArrowDown = (props : any) => {
    // fill="#293359"
    return (
        <svg width="10" height="13" viewBox="0 0 10 13" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.812 6.536h2.71V1.184c0-.27.214-.49.478-.49s.478.22.478.49v5.352h2.71c.175 0 .335.097.419.253a.499.499 0 0 1-.014.497l-3.188 5.18a.476.476 0 0 1-.405.229.476.476 0 0 1-.405-.229l-3.188-5.18a.503.503 0 0 1-.014-.497.476.476 0 0 1 .419-.253z" fill={props.color || '#293359'} fillRule="evenodd" fillOpacity=".491"/>
        </svg>
    );
}
